// Fetch availability
export const FETCH_CRYSTAL_AVAILABILITY_REQUEST = 'FETCH_CRYSTAL_AVAILABILITY_REQUEST';
export const fetchCrystalAvailabilityRequest = () =>
  ({ type: FETCH_CRYSTAL_AVAILABILITY_REQUEST });

export const FETCH_CRYSTAL_AVAILABILITY_SUCCESS = 'FETCH_CRYSTAL_AVAILABILITY_SUCCESS';
export const fetchCrystalAvailabilitySuccess = (available) =>
  ({ type: FETCH_CRYSTAL_AVAILABILITY_SUCCESS, payload: { available } });

export const FETCH_CRYSTAL_AVAILABILITY_FAILURE = 'FETCH_CRYSTAL_AVAILABILITY_FAILURE';
export const fetchCrystalAvailabilityFailure = (error) =>
  ({ type: FETCH_CRYSTAL_AVAILABILITY_FAILURE, payload: error });

// Fetch questionnaire
export const FETCH_CRYSTAL_QUESTIONNAIRE_REQUEST = 'FETCH_CRYSTAL_QUESTIONNAIRE_REQUEST';
export const fetchCrystalQuestionnaireRequest = () =>
  ({ type: FETCH_CRYSTAL_QUESTIONNAIRE_REQUEST });

export const FETCH_CRYSTAL_QUESTIONNAIRE_SUCCESS = 'FETCH_CRYSTAL_QUESTIONNAIRE_SUCCESS';
export const fetchCrystalQuestionnaireSuccess = (questions) =>
  ({ type: FETCH_CRYSTAL_QUESTIONNAIRE_SUCCESS, payload: { questions } });

export const FETCH_CRYSTAL_QUESTIONNAIRE_FAILURE = 'FETCH_CRYSTAL_QUESTIONNAIRE_FAILURE';
export const fetchCrystalQuestionnaireFailure = (error) =>
  ({ type: FETCH_CRYSTAL_QUESTIONNAIRE_FAILURE, payload: error });

// Submit questionnaire
export const SUBMIT_CRYSTAL_QUESTIONNAIRE_REQUEST = 'SUBMIT_CRYSTAL_QUESTIONNAIRE_REQUEST';
export const submitCrystalQuestionnaireRequest = (answers) =>
  ({ type: SUBMIT_CRYSTAL_QUESTIONNAIRE_REQUEST, payload: { answers } });

export const SUBMIT_CRYSTAL_QUESTIONNAIRE_SUCCESS = 'SUBMIT_CRYSTAL_QUESTIONNAIRE_SUCCESS';
export const submitCrystalQuestionnaireSuccess = (reading) =>
  ({ type: SUBMIT_CRYSTAL_QUESTIONNAIRE_SUCCESS, payload: { reading } });

export const SUBMIT_CRYSTAL_QUESTIONNAIRE_FAILURE = 'SUBMIT_CRYSTAL_QUESTIONNAIRE_FAILURE';
export const submitCrystalQuestionnaireFailure = (error) =>
  ({ type: SUBMIT_CRYSTAL_QUESTIONNAIRE_FAILURE, payload: error });

// Set reading like
export const SET_CRYSTAL_READING_LIKE_REQUEST = 'SET_CRYSTAL_READING_LIKE_REQUEST';
export const setCrystalReadingLikeRequest = (reading_id, like) =>
  ({ type: SET_CRYSTAL_READING_LIKE_REQUEST, payload: { reading_id, like } });

export const SET_CRYSTAL_READING_LIKE_SUCCESS = 'SET_CRYSTAL_READING_LIKE_SUCCESS';
export const setCrystalReadingLikeSuccess = () =>
  ({ type: SET_CRYSTAL_READING_LIKE_SUCCESS });

export const SET_CRYSTAL_READING_LIKE_FAILURE = 'SET_CRYSTAL_READING_LIKE_FAILURE';
export const setCrystalReadingLikeFailure = (error) =>
  ({ type: SET_CRYSTAL_READING_LIKE_FAILURE, payload: error });

// Fetch all crystals (catalog)
export const FETCH_ALL_CRYSTALS_REQUEST = 'FETCH_ALL_CRYSTALS_REQUEST';
export const fetchAllCrystalsRequest = () =>
  ({ type: FETCH_ALL_CRYSTALS_REQUEST });

export const FETCH_ALL_CRYSTALS_SUCCESS = 'FETCH_ALL_CRYSTALS_SUCCESS';
export const fetchAllCrystalsSuccess = (crystals) =>
  ({ type: FETCH_ALL_CRYSTALS_SUCCESS, payload: { crystals } });

export const FETCH_ALL_CRYSTALS_FAILURE = 'FETCH_ALL_CRYSTALS_FAILURE';
export const fetchAllCrystalsFailure = (error) =>
  ({ type: FETCH_ALL_CRYSTALS_FAILURE, payload: error });

// Capture lead (email gate)
export const CAPTURE_CRYSTAL_LEAD_REQUEST = 'CAPTURE_CRYSTAL_LEAD_REQUEST';
export const captureCrystalLeadRequest = (email, source, metadata) =>
  ({ type: CAPTURE_CRYSTAL_LEAD_REQUEST, payload: { email, source, metadata } });

export const CAPTURE_CRYSTAL_LEAD_SUCCESS = 'CAPTURE_CRYSTAL_LEAD_SUCCESS';
export const captureCrystalLeadSuccess = () =>
  ({ type: CAPTURE_CRYSTAL_LEAD_SUCCESS });

export const CAPTURE_CRYSTAL_LEAD_FAILURE = 'CAPTURE_CRYSTAL_LEAD_FAILURE';
export const captureCrystalLeadFailure = (error) =>
  ({ type: CAPTURE_CRYSTAL_LEAD_FAILURE, payload: error });

// Send free reading by email (link to public page)
export const SEND_CRYSTAL_READING_EMAIL_REQUEST = 'SEND_CRYSTAL_READING_EMAIL_REQUEST';
export const sendCrystalReadingEmailRequest = (email, reading_id) =>
  ({ type: SEND_CRYSTAL_READING_EMAIL_REQUEST, payload: { email, reading_id } });

export const SEND_CRYSTAL_READING_EMAIL_SUCCESS = 'SEND_CRYSTAL_READING_EMAIL_SUCCESS';
export const sendCrystalReadingEmailSuccess = () =>
  ({ type: SEND_CRYSTAL_READING_EMAIL_SUCCESS });

export const SEND_CRYSTAL_READING_EMAIL_FAILURE = 'SEND_CRYSTAL_READING_EMAIL_FAILURE';
export const sendCrystalReadingEmailFailure = (error) =>
  ({ type: SEND_CRYSTAL_READING_EMAIL_FAILURE, payload: error });

// Reset state
export const RESET_CRYSTALS = 'RESET_CRYSTALS';
export const resetCrystals = () =>
  ({ type: RESET_CRYSTALS });
